<template>
  <nav class="level level-netstat">
    <div class="level-item has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_blocks@2x.png')" alt="">
        </p>
        <p class="heading">BLOCKS</p>
        <p class="title">{{ blocks }}</p>
        <p class="card-line">
          <img :src="require('../../assets/card_line@2x.png')" alt="">
        </p>
        <p class="card-textbox">
          区块数
        </p>
      </div>
    </div>

    <div class="level-item has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_latest@2x.png')" alt="">
        </p>
        <p class="heading">LATEST</p>
        <p class="title">{{ lastBlockTime }}</p>
        <p class="card-line">
          <img :src="require('../../assets/card_line@2x.png')" alt="">
        </p>
        <p class="card-textbox">
          最后出块
        </p>
      </div>
    </div>

    <div class="level-item has-text-centered">
      <div class="status-card">
        <p class="card-icon">
          <img :src="require('../../assets/icon_txrate@2x.png')" alt="">
        </p>
        <p class="heading">TX/SEC</p>
        <p class="title">{{ transactionPerSecond}}</p>
        <p class="card-line">
          <img :src="require('../../assets/card_line@2x.png')" alt="">
        </p>
        <p class="card-textbox">
          每秒交易数
        </p>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'FirstNetworkStatus',
    computed: {
      ...mapState(['chainStatus']),
      blocks () {
        return this.$utils.addComma(this.chainStatus.blockHeight)
      },
      lastBlockTime () {
        if (this.chainStatus.lastBlockTime) {
          const last = this.chainStatus.lastBlockTime
          const d = new Date()
          const now = d.getTime()
          if (now / 1000 - last < 30) {
            return '' + parseInt(now / 1000 - last) + 's'
          } else {
            return this.$utils.fromNow(last)
          }
        } else {
          return 'n/a'
        }
      },
      transactionPerSecond () {
        return Number.parseFloat('' + this.chainStatus.transactionsPerHour / 3600).toFixed(3)
      }
    }
  }
</script>

<style scoped lang="scss">
  .level-netstat {
    position: relative;
    margin-top: -40%;
    margin-bottom: 20%;
  }

  .status-card {
    width: 12rem;
    height: 15rem;
    background-image: url("../../assets/status_card_bg@2x.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;

    p.card-icon img {
      margin-top: 16px;
      width: 56px;
      height: 56px;
    }

    p.heading {
      color: #4acb6b;
      font-size: 1.5rem;
      font-weight: 600;
      margin-top: 12px;
    }

    p.title {
      color: #4acb6b;
      font-size: 2rem;
      font-weight: normal;
    }

    p.card-line {
      height: 2px;
    }

    p.card-line img {
      margin-top: 12px;
      padding-left: 2rem;
      padding-right: 2rem;
    }

    p.card-textbox {
      color: #4acb6b;
      font-size: 1.5rem;
      font-weight: normal;
      border: 1px solid #4acb6b;
      margin-top: 3rem;
      margin-left: 2rem;
      margin-right: 2rem;
      padding-top: .2rem;
      padding-bottom: .2rem;
    }
  }

  @media screen and (max-width: 899px) {
    .status-card {
      width: 12rem;
      height: 15rem;
    }

    .level-netstat {
      padding-left: 4%;
      padding-right: 4%;
    }
  }

  @media screen and (max-width: 1086px) {
    .level-netstat {
      padding-left: 8%;
      padding-right: 8%;
    }

    p.card-textbox {
      margin-top: 1.5rem!important;
    }
  }

  @media screen and (min-width: 1087px) {
    .status-card {
      width: 14rem;
      height: 17.5rem;
    }

    .level-netstat {
      padding-left: 10%;
      padding-right: 10%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/FirstNetworkStatus.vue